module.exports = __webpack_public_path__ + "img/standard-user-settings.f0c490bc.png";